import { liningEmbroidery } from 'src/features/gorilla/drawer/common/back/embroidery'
import { State } from 'src/types'
import { lining } from '../lining'

export const liningDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  lining(ctx, state.linings.color)

  const isEmbroideryOfLiningFirst = state.embroideries.some((x) => x.position.value === 'leatherLiningFirst')
  // 平裏への刺繍
  if (isEmbroideryOfLiningFirst) {
    liningEmbroidery(
      ctx,
      state.embroideries.find((embroidery) => embroidery.position.value === 'leatherLiningFirst'),
      100,
      -15
    )
  }
  const isEmbroideryOfLiningSecond = state.embroideries.some((x) => x.position.value === 'leatherLiningSecond')
  // 平裏への刺繍
  if (isEmbroideryOfLiningSecond) {
    liningEmbroidery(
      ctx,
      state.embroideries.find((embroidery) => embroidery.position.value === 'leatherLiningSecond'),
      100,
      30
    )
  }
}
